/* ohhoney: kropki kolorow (podmiana karty), szybkie dodawanie, slider zdjec na telefonie */
(function () {
  if (window.ohCardsInit) return;
  window.ohCardsInit = true;

  var cache = {};
  function cardUrl(href) {
    var u = new URL(href, location.origin);
    var q = '?view=ohcard';
    if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && Shopify.theme.id) q += '&preview_theme_id=' + Shopify.theme.id;
    return u.pathname + q;
  }
  function loadCard(href) {
    var k = cardUrl(href);
    if (!cache[k]) {
      cache[k] = fetch(k, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('card');
        return r.text();
      });
      cache[k].catch(function () { delete cache[k]; });
    }
    return cache[k];
  }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  function prefetch(e) {
    var d = closest(e.target, 'product-card .oh-dot');
    if (d && !d.classList.contains('oh-dot--active')) loadCard(d.href).catch(function () {});
  }
  document.addEventListener('mouseover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });

  function closeAll(except) {
    document.querySelectorAll('.oh-qa.is-open').forEach(function (x) { if (x !== except) x.classList.remove('is-open'); });
  }

  function addToCart(id, btn) {
    var qa = closest(btn, '.oh-qa');
    if (!qa || qa.classList.contains('is-busy')) return;
    qa.classList.add('is-busy');
    var cd = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) { return s.section; });
      body.sections_url = location.pathname;
    }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        qa.classList.remove('is-busy');
        if (res && res.status && res.description) {
          var m = qa.querySelector('.oh-qa__msg');
          if (m) { m.textContent = res.description; qa.classList.add('has-msg'); setTimeout(function () { qa.classList.remove('has-msg'); }, 3000); }
          return;
        }
        qa.classList.remove('is-open');
        qa.classList.add('is-added');
        setTimeout(function () { qa.classList.remove('is-added'); }, 1800);
        if (cd && typeof cd.renderContents === 'function' && res.sections) {
          cd.renderContents(res);
        } else {
          location.href = root + 'cart';
        }
      })
      .catch(function () { qa.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    // 1) kropka koloru -> podmien karte na inny kolor
    var d = closest(e.target, 'product-card .oh-dot');
    if (d) {
      e.preventDefault();
      if (d.classList.contains('oh-dot--active')) return;
      var card = d.closest('product-card');
      card.classList.add('oh-is-loading');
      loadCard(d.href)
        .then(function (html) {
          var w = document.createElement('div');
          w.innerHTML = html;
          var n = w.querySelector(':scope > product-card');
          if (!n) throw new Error('card');
          card.replaceWith(n);
        })
        .catch(function () { location.href = d.href; });
      return;
    }
    // 2) szybkie dodawanie
    var o = closest(e.target, '.oh-qa__open');
    if (o) {
      e.preventDefault(); e.stopPropagation();
      if (o.dataset.id) { addToCart(o.dataset.id, o); return; }
      var qa = o.closest('.oh-qa');
      closeAll(qa);
      qa.classList.add('is-open');
      return;
    }
    var s = closest(e.target, '.oh-qa__size');
    if (s) {
      e.preventDefault(); e.stopPropagation();
      if (!s.disabled) addToCart(s.dataset.id, s);
      return;
    }
    if (!closest(e.target, '.oh-qa')) closeAll();
  });

  // 3) wskaznik slidera zdjec (telefon)
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('oh-slides')) return;
    var i = Math.round(t.scrollLeft / Math.max(t.clientWidth, 1));
    var bar = t.parentElement.querySelector('.oh-slides__bar');
    if (!bar) return;
    Array.prototype.forEach.call(bar.children, function (el, j) { el.classList.toggle('is-active', j === i); });
  }, true);
  document.addEventListener('scrollend', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('oh-slides')) t.dispatchEvent(new Event('scroll'));
  }, true);
})();
